import PropTypes from "prop-types"
import { Person } from "@mui/icons-material"
import { connect } from "react-redux"
import { get } from "lodash"
import Header from "modules/home-header"

function ResourceMembersHeader({ account, name }) {
  const resourceName = name ? `Resource Permissions: ${name} ` : "Resource Permissions"

  return <Header Icon={Person} title={resourceName} account={account} />
}

ResourceMembersHeader.propTypes = {
  account: PropTypes.string.isRequired,
  name: PropTypes.string,
}

export default connect(state => ({ name: get(state, "global.data.resourceMembers.data.resource.name") }), null)(ResourceMembersHeader)
